<i (click)="initData()"
   class="fas fa-plus services-select__icon services-icon--add services-icon--inline"></i>

<div bsModal
     #lgModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-labelledby="myLargeModalLabel"
     aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-header">
            <h4 class="modal-title"
                id="myModalLabel">{{ 'modal.registrations_title' | translate }}</h4>
            <button type="button"
                    class="close"
                    (click)="lgModal.hide()">✕</button>
        </div>
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="panel panel-default table-dynamic">
                            <div class="table-filters">
                                <div class="row">
                                    <div class="col-md-12">
                                        <form class="pristine valid">
                                            <input type="text"
                                                   [(ngModel)]="userFilter.name"
                                                   name="search"
                                                   placeholder="{{ 'general.search' | translate }}"
                                                   class="form-control">
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <ul class="list-group"
                                *ngIf="notSelectedRegistrationsList">
                                <li class="list-group-item"
                                    (click)="registrationId = item.id"
                                    *ngFor="let item of notSelectedRegistrationsList | filterBy: userFilter"
                                    [class.active]="registrationId === item.id">
                                    <span class="list-group-item-text">{{item.name}}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <form>
                                <div class="form-group">
                                    <input type="hidden"
                                           name="registrationId"
                                           value="{{registrationId}}"
                                           [(ngModel)]="registrationId">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <button type="submit"
                                                    (click)="createRoleRegistration(); lgModal.hide()"
                                                    class="btn btn-w-md btn-gap-v btn-line-success btn-block">{{ 'Save' | translate }}
                      </button>
                                        </div>
                                        <div class="col-md-6">
                                            <button (click)="lgModal.hide()"
                                                    class="btn btn-w-md btn-gap-v btn-line-warning btn-block">{{
                        'Cancel' | translate }}
                      </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
